import ApiEndpointConstants from "../constants/api/ApiEndpointConstants";
import api from "./API";

export const submitOrder = (params) => {
  return api.post('https://www.stripe.baby/api/Urlorder/setOrder', params);
};
